function SahwariArabDemocraticRepublic({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1990)">
  <path d="M1.58763 9.04366C0.5705 11.1472 0 13.507 0 16.0002C0 18.4933 0.5705 20.8532 1.58763 22.9567L16 24.348L30.4124 22.9567C31.4295 20.8532 32 18.4933 32 16.0002C32 13.507 31.4295 11.1472 30.4124 9.04366L16 7.65234L1.58763 9.04366Z" fill="#F0F0F0"/>
  <path d="M1.58813 22.957C4.17601 28.309 9.65663 32.0005 15.9999 32.0005C22.3433 32.0005 27.8239 28.309 30.4117 22.957H1.58813Z" fill="#496E2D"/>
  <path d="M1.58813 9.0435H30.4117C27.8239 3.69156 22.3433 0 15.9999 0C9.65657 0 4.17601 3.69156 1.58813 9.0435Z" fill="black"/>
  <path d="M4.68628 4.68555C-1.56209 10.9339 -1.56209 21.0646 4.68628 27.313C7.26834 24.731 9.75165 22.2477 16 15.9993L4.68628 4.68555Z" fill="#D80027"/>
  <path d="M20.1739 15.9985C20.1739 13.6673 21.8122 11.7199 24 11.2422C23.6637 11.1687 23.3149 11.1289 22.9565 11.1289C20.267 11.1289 18.0869 13.309 18.0869 15.9985C18.0869 18.6879 20.267 20.868 22.9565 20.868C23.3148 20.868 23.6637 20.8282 24 20.7548C21.8122 20.277 20.1739 18.3296 20.1739 15.9985Z" fill="#D80027"/>
  <path d="M24.2046 12.8691L24.8954 14.995H27.1304L25.3222 16.3086L26.0129 18.4344L24.2046 17.1206L22.3964 18.4344L23.0872 16.3086L21.2788 14.995H23.5139L24.2046 12.8691Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default SahwariArabDemocraticRepublic;
